module.exports = __webpack_public_path__ + "media/src/assets/fonts/Montserrat-Black-f86a4fdb233e1ca195b64712ac9c7cbe.otf";